import React, { useState, useEffect } from 'react';
import { adminAPI } from '@/services';
import { useToast } from '../components/Toast';
import PageHeader from '../components/PageHeader';

const SaasSystemInfo = () => {
  const { error: showError } = useToast();
  const [systemInfo, setSystemInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSystemInfo();
  }, []);

  const loadSystemInfo = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.getSystemInfo();
      setSystemInfo(response.data);
    } catch (err) {
      showError('Erreur lors du chargement des informations système');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatBytes = (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-entrea-royal mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Informations système - Administration SaaS"
        description="Informations techniques sur le serveur et la base de données"
      />

      {systemInfo && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Informations système */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Système</h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <span className="text-sm text-gray-600">Plateforme</span>
                <span className="text-sm font-medium text-gray-900">{systemInfo.system?.platform || '-'}</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <span className="text-sm text-gray-600">Version Python</span>
                <span className="text-sm font-medium text-gray-900">
                  {systemInfo.system?.python_version?.split(' ')[0] || '-'}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <span className="text-sm text-gray-600">Heure serveur</span>
                <span className="text-sm font-medium text-gray-900">
                  {systemInfo.server_time ? new Date(systemInfo.server_time).toLocaleString('fr-FR') : '-'}
                </span>
              </div>
            </div>
          </div>

          {/* Informations base de données */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Base de données</h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <span className="text-sm text-gray-600">Nom</span>
                <span className="text-sm font-medium text-gray-900">{systemInfo.system?.database?.name || '-'}</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <span className="text-sm text-gray-600">Taille</span>
                <span className="text-sm font-medium text-gray-900">
                  {formatBytes(systemInfo.system?.database?.size || 0)}
                </span>
              </div>
            </div>
          </div>

          {/* Collections */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 md:col-span-2">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Collections et documents</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {systemInfo.system?.database?.collections && Object.entries(systemInfo.system.database.collections).map(([collection, count]) => (
                <div key={collection} className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600 font-medium">{collection}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-1">{count}</p>
                  <p className="text-xs text-gray-500 mt-1">document{count > 1 ? 's' : ''}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SaasSystemInfo;

